/**
 * FDM Thresholds Tab Component
 * Configure detection thresholds for flight data parameters
 */

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Settings, Target } from 'lucide-react';

export default function FDMThresholdsTab({ 
  thresholds, 
  onAddThreshold 
}) {
  return (
    <div className="space-y-4 mt-6">
      <Card className="bg-slate-800/50 border-slate-700">
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle className="text-lg text-slate-100">Exceedance Thresholds</CardTitle>
              <CardDescription>Configure detection thresholds for flight data parameters</CardDescription>
            </div>
            <Button variant="outline" size="sm" onClick={onAddThreshold} data-testid="add-threshold-btn">
              <Settings className="w-4 h-4 mr-2" />
              Add Threshold
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            {thresholds.map((threshold) => (
              <div key={threshold.id} className="flex items-center justify-between p-4 rounded-lg bg-slate-700/30">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-slate-200">{threshold.name}</span>
                    {threshold.is_system && <Badge variant="outline" className="text-xs">System</Badge>}
                  </div>
                  <p className="text-sm text-slate-400 mt-1">
                    {threshold.parameter} • {threshold.operator?.replace('_', ' ')} • {threshold.unit}
                  </p>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  {threshold.level_1_threshold && <Badge className="bg-blue-500/20 text-blue-400">L1: {threshold.level_1_threshold}</Badge>}
                  {threshold.level_3_threshold && <Badge className="bg-orange-500/20 text-orange-400">L3: {threshold.level_3_threshold}</Badge>}
                  {threshold.level_5_threshold && <Badge className="bg-red-500/20 text-red-400">L5: {threshold.level_5_threshold}</Badge>}
                </div>
              </div>
            ))}
            {thresholds.length === 0 && (
              <div className="text-center py-12">
                <Target className="w-12 h-12 text-slate-600 mx-auto mb-3" />
                <p className="text-slate-400">No thresholds configured</p>
                <p className="text-slate-500 text-sm mt-1">Seed demo data to load standard aviation thresholds</p>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
